if (!customElements.get("stmt-video")) {
  class Video extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector(".js-video");
      this.playButton = this.querySelector(".js-play-button");

      this.addEventListeners();
    }

    addEventListeners() {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }

    playVideo() {
      this.video.play();

      this.playButton.classList.add("js-video-hidden");
    }
  }

  customElements.define("stmt-video", Video);
}